const selectBase = state => state.modals.hotkeys

export const selectIsHotkeysModalVisible = state => selectBase(state).visible
